var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { User } from '@/models/User';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import { Participant } from '@/models/Participant';
import ErrorHandler from '@/support/ErrorHandler';
let AddChatUser = class AddChatUser extends Vue {
    constructor() {
        super(...arguments);
        // protected userModel: User = new User();
        this.selectedUsers = [];
        this.clearSelects = false;
    }
    close() {
        this.$emit('input', false);
    }
    createPayload() {
        return {
            room: this.room,
            users: this.selectedUsers.map((user) => {
                return user.value;
            }),
        };
    }
    update() {
        if (!this.room) {
            return;
        }
        new Participant()
            .include('roles')
            .filter('room', this.room)
            .create(this.createPayload())
            .then((participants) => {
            this.$emit('usersAdded', participants);
            this.close();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    initialize() { }
    mounted() {
        this.initialize();
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], AddChatUser.prototype, "room", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], AddChatUser.prototype, "userModel", void 0);
AddChatUser = __decorate([
    Component({
        components: {
            AsyncSelect,
        },
    })
], AddChatUser);
export default AddChatUser;
